module.exports = __webpack_public_path__ + "assets/img/kv-05be101d.jpg";